/**
 * Options for a scene listener
 */
export class SceneListenerOptions {
    /**
     * Construct the options with default values as necessary
     *
     * @param replayCurrentScene
     * @param disableGeometryEvents
     * @param disableTransformEvents
     */
    constructor(replayCurrentScene = true, disableGeometryEvents = false, disableTransformEvents = true) {
        this.replayCurrentScene = replayCurrentScene;
        this.disableGeometryEvents = disableGeometryEvents;
        this.disableTransformEvents = disableTransformEvents;
    }
}
/** The default options */
SceneListenerOptions.defaults = new SceneListenerOptions();
